import { Fragment, useRef, useState } from "react";
import { AsyncTypeahead } from "react-bootstrap-typeahead";
import { PUBLIC_URL } from "../serviceWorker";
import { useNavigate } from "react-router-dom";

const SearchProducts = () => {
  const SEARCH_URI = PUBLIC_URL + "api/shop/fetch_search";
  //const [isLoading, setIsLoading] = useState(false);
  const ref = useRef<any>(null);
  const navigate: any = useNavigate()
  const [options, setOptions] = useState([]);
  const container = (document.getElementById(
    "container"
  ) as unknown) as HTMLDivElement;

  const handleSearch = (query: any) => {
    fetch(`${SEARCH_URI}?q=${query}`)
      .then((resp) => resp.json())
      .then(({ items }) => {
        const options = items.map((i: { id: number; name: string; }) => ({
          id: i.id,
          name: i.name,
        }));
        if (query.length === 12 && items.length === 1) {
          setOptions([])
          ref.current.clear()
          navigate("/product/" + items[0].id)
        } else {
          setOptions(options)
        }
      });
  };

  // Bypass client-side filtering by returning `true`. Results are already
  // filtered by the search endpoint, so no need to do it again.
  const filterBy = () => true;

  return (
    <AsyncTypeahead
      className="me-3"
      filterBy={filterBy}
      ref={ref}
      id="async-example"
      isLoading={false}
      labelKey={(option: any) => `${option.name}`}
      minLength={3}
      onSearch={handleSearch}
      options={options}
      placeholder="Buscar..."
      emptyLabel={"No se encontraron disponibles"}
      size={"lg"}
      clearButton
      onChange={(option: any) => {
        option.length && navigate("/product/" + option[0].id);
        ref.current.clear();
        container.click();
      }}
      renderMenuItemChildren={(
        option: any,
        props,
        index: any
      ) => (
        <Fragment key={index}>
          <span>{option.name}</span>
        </Fragment>
      )}
    />
  );
};

export default SearchProducts;
